import { BreadcrumbItem } from "Components/Breadcrumb/Breadcrumb";

export const TRAINING_VIDEO_TITLE = "Training Videos";

export const breads: BreadcrumbItem[] = [
  { title: TRAINING_VIDEO_TITLE, link: "" },
];
